// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import axios, { AxiosError, AxiosInstance } from 'axios';

import getApiError from './getApiError';
import { launcherApi } from './setupLauncherApi';
import { merchantApi } from './setupMerchantApi';

export const getLoginClientApi = (): AxiosInstance => {
  const apiClient = axios.create();
  apiClient.defaults.baseURL = process.env.LOGIN_API_URL || 'https://login.xsolla.com/api';
  apiClient.defaults.withCredentials = true;
  apiClient.defaults.validateStatus = (status) => status >= 200 && status < 300;
  if (process.env.NODE_ENV === 'development') {
    apiClient.defaults.headers.common.Authorization = `Bearer ${process.env.PUBLISHER_TOKEN}`;
  }

  apiClient.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      if (
        error.response &&
        (error.response.status === 401 || error.response.status === 403) &&
        !error.response.config.url.includes(process.env.LOGIN_API_URL)
      ) {
        const interceptorError = {
          code: '999-999',
          description: 'Invalid token.'
        };
        error.response.data.error = interceptorError; // eslint-disable-line no-param-reassign
      }

      return Promise.reject(getApiError(error));
    }
  );

  return apiClient;
};

export const getLoginClientApiNoIntercept = (): AxiosInstance => {
  const apiClient = axios.create();
  apiClient.defaults.baseURL = process.env.LOGIN_API_URL || 'https://login.xsolla.com/api';
  apiClient.defaults.withCredentials = true;
  apiClient.defaults.validateStatus = (status) => status >= 200 && status < 300;

  if (process.env.NODE_ENV === 'development') {
    apiClient.defaults.headers.common.Authorization = `Bearer ${process.env.PUBLISHER_TOKEN}`;
  }

  return apiClient;
};

export const loginApi = getLoginClientApi();
export const loginApiNoIntercept = getLoginClientApiNoIntercept();

export const setHTTPToken = (token: string): void => {
  loginApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  loginApiNoIntercept.defaults.headers.common.Authorization = `Bearer ${token}`;
  merchantApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  launcherApi.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export const clearHTTPToken = (): void => {
  loginApi.defaults.headers.common.Authorization = null;
  loginApiNoIntercept.defaults.headers.common.Authorization = null;
  merchantApi.defaults.headers.common.Authorization = null;
  launcherApi.defaults.headers.common.Authorization = null;
};
